import {ChangeEvent, FormEvent, forwardRef, useEffect, useState} from 'react';
import {SearchIcon} from '@/components/Icons';
import {TextField} from '@/components/TextField';

interface IProps {
  defaultValue?: string;
  disabled?: boolean;
  onSubmit(keyword: string): void;
}

export const SearchBar = forwardRef<HTMLInputElement, IProps>(
  ({defaultValue, disabled, onSubmit}, ref) => {
    const [keyword, setKeyword] = useState<string>(defaultValue || '');

    const handleSubmit = (e: FormEvent) => {
      e.preventDefault();

      onSubmit(keyword);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      setKeyword(e.target.value);
    };

    useEffect(() => {
      setKeyword(defaultValue || '');
    }, [defaultValue]);

    return (
      <form onSubmit={handleSubmit}>
        <TextField
          ref={ref}
          variant="medium"
          type="text"
          name="keyword"
          placeholder="상호명을 검색해 주세요"
          icon={SearchIcon}
          disabled={disabled}
          value={keyword || ''}
          onChange={handleChange}
        />
      </form>
    );
  }
);
